"use strict";

var _underscore = require("underscore");
var _tinycolor = _interopRequireDefault(require("tinycolor2"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var THEME_BIT_TYPE = 'theme-bit';
var THEME_BIT_ID = 'bstg-theme-bit:base';
var THEME_BIT_PRIORITY = 9999;
var THEMES = {
  dark: {
    foregroundColor1: '#E4E6EB',
    foregroundColor2: '#B1B3B8',
    backgroundColor1: '#3F4041',
    backgroundColor2: '#303336',
    backgroundColor3: '#252627',
    backgroundColor4: '#18191A',
    backgroundColor5: 'rgba(255, 255, 255, 0.05)',
    activeLinkStyle: 'underline'
  },
  light: {
    foregroundColor1: '#18191A',
    foregroundColor2: '#7D8082',
    backgroundColor1: '#F3F3F3',
    backgroundColor2: '#DDDDDD',
    backgroundColor3: '#FFFFFF',
    backgroundColor4: '#F7F7F7',
    backgroundColor5: 'rgba(0, 0, 0, 0.05)',
    activeLinkStyle: 'background'
  }
};
// Helpers used in expandTheme
// Backround & Title font colour
var bt = function bt(ctx, opts) {
  return (0, _underscore.extend)({
    background_color: ctx.backgroundColor,
    title: {
      font_color: ctx.color
    }
  }, opts || {});
};
// BackGround
var bg = function bg(ctx, opt) {
  return (0, _underscore.extend)({
    background_color: ctx.backgroundColor
  }, opt || {});
};
// Font colour
var fc = function fc(ctx, opt) {
  return (0, _underscore.extend)({
    font_color: ctx.color
  }, opt || {});
};
// Bacgrkound & Font colour
var bf = function bf(ctx, opt) {
  return (0, _underscore.extend)({
    background_color: ctx.backgroundColor,
    font_color: ctx.color
  }, opt || {});
};
var ThemeService = /*#__PURE__*/function () {
  ThemeService.$inject = ["$http", "bulkUpdateService", "eventService"];
  /* @ngInject */
  function ThemeService($http, bulkUpdateService, eventService) {
    _classCallCheck(this, ThemeService);
    this.$http = $http;
    this.bulkUpdateService = bulkUpdateService;
    this.eventService = eventService;
  }
  return _createClass(ThemeService, [{
    key: "compileTheme",
    value: function compileTheme(eventId) {
      return this.$http.post("/api/v1/eid/".concat(eventId, "/compile/theme"));
    }
  }, {
    key: "getEventTheme",
    value: function getEventTheme(eventId, eventNode) {
      return this.eventService.getEventDocById({
        _id: eventId,
        node: eventNode
      }, 'theme').then(function (_ref) {
        var data = _ref.data;
        return data;
      }, function () {
        return {};
      });
    }
  }, {
    key: "getThemeBit",
    value: function getThemeBit(eventId, eventNode) {
      var bitId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : THEME_BIT_ID;
      return this.eventService.getEventDocById({
        _id: eventId,
        node: eventNode
      }, bitId).then(function (_ref2) {
        var data = _ref2.data;
        return data;
      }, function () {
        return {};
      });
    }

    // we're not doing dictree.diff/merge here because we're not saving the whole theme here
    // unlike in spotman, where the whole spotman is being held in view state
    // also we never delete properties (pruning) here nor have weird array behaviour as in navs
  }, {
    key: "saveThemeBit",
    value: function saveThemeBit(eventId, eventNode, compactedTheme) {
      var _this = this;
      var bitId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : THEME_BIT_ID;
      var newThemeBit = this.expandCompactedTheme(compactedTheme);
      return this.getThemeBit(eventId, eventNode, bitId).then(function (currentBit) {
        (0, _underscore.extend)(newThemeBit, {
          _id: currentBit._id || bitId,
          _rev: currentBit._rev,
          fp_owner: 'private',
          fp_type: THEME_BIT_TYPE,
          fp_bit_priority: THEME_BIT_PRIORITY,
          fp_ext_id: currentBit.fp_ext_id || currentBit._id || bitId
        });
        return _this.bulkUpdateService[currentBit._rev ? 'updateDoc' : 'createDocs'](eventId, eventNode, THEME_BIT_TYPE, newThemeBit, {
          keepId: true
        }).then(_this.compileTheme.bind(_this, eventId, eventNode));
      });
    }

    // Simplifies theme.json to a CSS-like structure
  }, {
    key: "compactTheme",
    value: function compactTheme(themeDoc) {
      var toolbar = themeDoc.layouts.navigation_bar;
      var mainTabBar = themeDoc.layouts.navigation_tab_bar;
      var listRow = themeDoc.layouts.list_row;
      var spotman = themeDoc.navs.nav_spotman;
      var loadingView = themeDoc.layouts.loading_view;
      var initNav = themeDoc.navs.instantiation_nav;
      var spotmanRow = spotman.spotmansectionheaderrow_nav;
      var countBadge = spotman.list_row.subtitle;
      var profilePhotoIsRounded = spotman.profilerow_nav.image_view.is_rounded;
      var navHome = themeDoc.navs.nav_home || {
        view: {
          background_color: themeDoc.navs.blocks_nav.view.background_color || '#e6e6e6'
        }
      };
      var fonts = themeDoc.fonts || {};
      var spotmanListRowTitleSelected = spotman.list_row.title._selected || {};
      var loadingViewBackgroundColor = (0, _tinycolor.default)(loadingView.background_color || '#000');
      var spotmanIcon = (spotman.list_row.image_view || {}).icons_color;
      return {
        appearance: themeDoc.appearance,
        fonts: {
          regular: fonts.font_regular_name,
          bold: fonts.font_bold_name,
          italic: fonts.font_italic_name
        },
        primaryColor: toolbar.background_color,
        toolbar: {
          backgroundColor: toolbar.background_color,
          color: toolbar.title.font_color
        },
        spotman: {
          view: {
            backgroundColor: spotman.list_row.background_color,
            color: spotman.list_row.title.font_color,
            iconsColorEnabled: spotmanIcon ? spotmanIcon.enabled : true,
            iconsColor: spotmanIcon ? spotmanIcon.color : spotman.list_row.title.font_color,
            selected: {
              color: spotmanListRowTitleSelected.font_color || spotman.list_row.title.font_color,
              backgroundColor: spotman.list_row._selected.background_color
            }
          },
          alt_view: {
            backgroundColor: spotmanRow.background_color,
            color: spotmanRow.title.font_color
          },
          profile: {
            backgroundColor: spotman.profilerow_nav.background_color || spotman.list_row.background_color,
            roundedPhoto: profilePhotoIsRounded === undefined ? true : profilePhotoIsRounded,
            title: {
              color: spotman.profilerow_nav.title.font_color
            },
            subtitle: {
              color: spotman.profilerow_nav.subtitle.font_color
            }
          }
        },
        list: listRow && listRow.title && listRow.title._selected && listRow._selected ? {
          selected: {
            color: listRow.title._selected.font_color,
            backgroundColor: listRow._selected.background_color
          }
        } : undefined,
        home: {
          backgroundColor: navHome.view.background_color
        },
        splashscreen: {
          backgroundColor: loadingViewBackgroundColor.toHexString(),
          backgroundColorOpacity: loadingViewBackgroundColor.getAlpha() * 100,
          margin: {
            phone: parseFloat(loadingView.margin_top, 10) * 100,
            tablet: parseFloat(loadingView._tablet.margin_top, 10) * 100
          },
          spinner: {
            color: (initNav.activity_indicator || themeDoc.layouts.activity_indicator).tint_color || '#fff'
          },
          progressBar: {
            backgroundColor: (initNav.progress_view || themeDoc.layouts.progress_view).background_color || '#c0c0c0',
            fill: {
              backgroundColor: (initNav.progress_view || themeDoc.layouts.progress_view).progression_color || '#fff'
            }
          },
          text: {
            color: initNav.title.font_color
          }
        },
        mainTabBar: mainTabBar ? {
          activeColor: mainTabBar.item_active || toolbar.background_color
        } : undefined,
        notificationBadge: listRow.badge ? {
          backgroundColor: listRow.badge.inset_color,
          color: listRow.badge.font_color
        } : undefined,
        countBadge: countBadge ? {
          backgroundColor: countBadge.background_color,
          color: countBadge.font_color
        } : undefined,
        iosStatusBar: themeDoc.layouts.status_bar.font_color || '#fff',
        checkmark: listRow.checkmark_color
      };
    }

    // Converts object returned by compactTheme into a theme.json-compatibile structure
  }, {
    key: "expandCompactedTheme",
    value: function expandCompactedTheme(compactedTheme) {
      var t = compactedTheme;
      var tag = {
        tag: bf(t.toolbar)
      };
      var listRowSelectedFontColor = t.list && t.list.selected ? {
        _selected: fc(t.list.selected)
      } : undefined;
      var loadingViewBackgroundColor = (0, _tinycolor.default)(t.splashscreen.backgroundColor).setAlpha(t.splashscreen.backgroundColorOpacity / 100).toRgbString();
      var appearance = THEMES[t.appearance] || {};

      // new theme.json
      return _objectSpread(_objectSpread({}, appearance), {}, {
        theming_version: t.appearance && THEMES[t.appearance] ? 3 : 2,
        appearance: t.appearance,
        contrastColor: t.primaryColor,
        primary_color: t.primaryColor,
        layouts: {
          navigation_bar: bt(t.toolbar),
          tool_bar: bt(t.toolbar),
          list: {
            separator_color: '#ddd'
          },
          list_row: t.list || t.notificationBadge ? {
            checkmark_color: t.checkmark,
            _selected: t.list && t.list.selected ? bg(t.list.selected) : undefined,
            title: listRowSelectedFontColor,
            subtitle: listRowSelectedFontColor,
            body: listRowSelectedFontColor,
            datetime: listRowSelectedFontColor,
            badge: t.notificationBadge ? {
              inset_color: t.notificationBadge.backgroundColor,
              frame_color: t.notificationBadge.backgroundColor,
              font_color: t.notificationBadge.color,
              inset_gradient_enabled: false,
              shadow_enabled: false
            } : undefined
          } : undefined,
          status_bar: t.iosStatusBar ? {
            font_color: t.iosStatusBar
          } : undefined,
          bar_button: bt(t.toolbar, {
            tint_color: t.toolbar.color
          }),
          navigation_tab_bar: {
            item_active: t.mainTabBar.activeColor
          },
          loading_view: {
            background_color: loadingViewBackgroundColor,
            margin_top: (parseInt(t.splashscreen.margin.phone, 10) / 100).toFixed(2),
            _tablet: {
              margin_top: (parseInt(t.splashscreen.margin.tablet, 10) / 100).toFixed(2)
            }
          }
        },
        navs: {
          instantiation_nav: t.splashscreen ? {
            title: fc(t.splashscreen.text),
            progress_view: {
              background_color: t.splashscreen.progressBar.backgroundColor,
              progression_color: t.splashscreen.progressBar.fill.backgroundColor
            },
            activity_indicator: {
              tint_color: t.splashscreen.spinner.color
            }
          } : undefined,
          nav_spotman: {
            view: bg(t.spotman.view),
            list_row: bt(t.spotman.view, {
              title: fc(t.spotman.view, {
                _selected: fc(t.spotman.view.selected)
              }),
              subtitle: t.countBadge ? bf(t.countBadge, {
                _selected: bf(t.countBadge)
              }) : undefined,
              image_view: {
                icons_color: {
                  enabled: t.spotman.view.iconsColorEnabled,
                  color: t.spotman.view.iconsColor
                }
              },
              _selected: bg(t.spotman.view.selected)
            }),
            list: {
              separator_color: t.spotman.view.backgroundColor
            },
            spotmansectionheaderrow_nav: bt(t.spotman.alt_view),
            profilerow_nav: bg(t.spotman.view, {
              image_view: {
                is_rounded: t.spotman.profile.roundedPhoto
              },
              title: fc(t.spotman.profile.title, {
                _selected: fc(t.spotman.profile.title)
              }),
              subtitle: fc(t.spotman.profile.subtitle, {
                _selected: fc(t.spotman.profile.subtitle)
              })
            })
          },
          nav_home: t.home ? {
            view: bg(t.home)
          } : undefined,
          nav_home1: t.home ? {
            view: bg(t.home),
            _tablet: bg(t.home)
          } : undefined,
          votecomment_nav: t.list && t.list.selected ? {
            list_row: {
              button: {
                title: {
                  _selected: fc(t.list.selected)
                },
                _selected: bg(t.list.selected),
                _highlighted: bg(t.list.selected)
              }
            }
          } : undefined,
          carousel_nav: {
            view: bg(t.toolbar)
          },
          conversation_nav: {
            conversationrow_nav: {
              body: bf(t.toolbar)
            }
          },
          newmeeting_nav: tag,
          newmessage_nav: tag
        }
      });
    }
  }]);
}();
angular.module('backstage.services').service('themeService', ThemeService)
// backwards compatibility for packages (used in `pkg-spotman-menu-editor`)
.service('c_themeService', ThemeService);